<template>
    <div v-if="!getIsHidden()" :class="getContainerClass()" :key="label + hasError()">

      <div class="py-0" :class="indent !== false ? 'row' : null">
        <label v-if="label !== false" class="col-sm-4 col-form-label">{{label}}<span v-if="getIsRequired()" class="required">*</span></label>

        <div :class="indent !== false ? 'col-sm-8' : null">
          <slot :hasError="hasError()"></slot>
        </div>
      </div>

      <div class="error py-0 row" v-if="error">
        <div v-if="indent !== false" class="col-sm-4"></div>
        <div :class="indent !== false ? 'col-sm-8' : 'col-sm-12'">
          <div class="error" v-if="hasError()">
            <div v-for="(err, index) in error" :key="index">
              {{ err }}
            </div>
          </div>
          <div v-else>{{ error }}</div>
        </div>
      </div>
    </div>
</template>

<script>

  export default {
    name: 'form-control',
    props: ['label', 'indent', 'required', 'hidden', 'disabled', 'containerClass'],
    data() {
      return {
        Array: Array,
        error: null,
        _required: this.required,
        _hidden: this.hidden,
        _disabled: this.disabled,
      }
    },
    methods: {
      getContainerClass() {
        const cl = this.containerClass ? this.containerClass : {
          'form-group': true,
          'py-0': true,
          'disabled': this.getIsDisabled()
        };

        cl['has-error'] = this.hasError();

        return cl;
      },
      clearError() {
        this.error = null;
      },
      hasError() {
        return !!this?.error?.length
      },
      setError(err) {
        this.error = err;
      },
      setRequired(required) {
        this._required = required;
      },
      getIsRequired() {
        if (this.required === false) return false;

        return this.required || this._required;
      },
      setHidden(hidden) {
        this._hidden = hidden;
      },
      setDisabled(disabled) {
        this._disabled = disabled;

        this.$emit('disabled', disabled);
      },
      getIsHidden() {
        if (this.hidden === false) return false;

        return this.hidden || this._hidden;
      },
      getIsDisabled() {
        if (this.disabled === false) return false;

        return this.disabled || this._disabled;
      },
    }
  }
</script>

<style lang="scss" scoped>
  div.disabled {
    opacity: 0.5;
  }
</style>
